import { css } from '@emotion/react'
import { Typography, Color } from '@opallabs/gem'

export const summaryContainer = css({
  backgroundColor: '#182229',
  padding: '12px',
  display: 'flex',
  flexDirection: 'column',
})

export const summaryItem = css({
  ...Typography.T300,
  backgroundColor: '#182229',
  lineHeight: 1,
  color: Color.dark.Text.Default,
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  borderRadius: 0,
  border: 'none',
  cursor: 'pointer',
  gap: '4px',
  minHeight: '26px',
  padding: '0 4px',
  '&:hover': {
    backgroundColor: '#6F7D89',
  },
})

export const summaryText = css({
  flex: 1,
  textAlign: 'left',
})
